import React, { useEffect, useState } from 'react';
import { BrowserRouter, BrowserRouter as Router } from "react-router-dom";
import ContactUsPage from './Pages/ContactUs/ContactUsPage';
import BookingDetailsPage from './Pages/BookingDetails/BookingDetailsPage';
import BookingPaymentsPage from './Pages/BookingPayments/BookingPaymentsPage';
import FaqsPage from './Pages/Faqs/FaqsPage';
import HomePage from './Pages/Home/HomePage';
import Layout from './Components/Layout';
import LicenceCheckPage from './Pages/LicenceCheck/LicenceCheckPage';
import MotorhomePage from './Pages/Motorhomes/MotorhomePage';
import MyAccountPage from './Pages/MyAccount/MyAccountPage';
import PaymentProcessPage from './Pages/Payment/PaymentProcess';
import PrivacyCookieNoticePage from './Pages/PrivacyCookieNotice/PrivacyCookieNoticePage';
import UseOfCookiesPage from './Pages/UseOfCookies/UseOfCookiesPage';
import { Route, Routes } from 'react-router';
import CheckAvailabilityPage from './Pages/CheckAvailability/CheckAvailabilityPage';
import PrivateRoute from './Components/PrivateRoute';
import ConfigContextProvider from 'ConfigContextProvider';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from 'authConfig';
import { PublicClientApplication } from '@azure/msal-browser';
import { AppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "./appInsightsAuth";
import axios from 'axios';
import { globalConfigUrl } from 'Configuration/config';
import ReactGA from "react-ga4";
import 'Styles/main.css';
import 'react-toastify/dist/ReactToastify.css';
ReactGA.initialize("G-X8CW05489S");

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');

function App() {

    const [authConfig, setAuthConfig] = useState<any>();

    useEffect(()=>{
        const fetchConfig = async () => { 
            await axios.get(globalConfigUrl).then((response:any) => {
                const config = {...msalConfig};
                config.auth.clientId = response.data.b2cClientId;
                config.auth.authority = response.data.b2cSignUpAuthority;
                config.auth.knownAuthorities.push(response.data.b2cAuthorityDomain);
                setAuthConfig(config)
            });
        };
        fetchConfig();
        
        ReactGA.send({ hitType: "pageview", page: window.location.pathname });
    },[])

    ReactGA.initialize("G-X8CW05489S");
    if(authConfig){
        const instance = new PublicClientApplication(authConfig);
        
        return (
            <BrowserRouter basename={baseUrl as string |undefined}>
                <MsalProvider instance={instance}>
                    <ConfigContextProvider>
                        <AppInsightsContext.Provider value={reactPlugin}>
                            <Layout>
                                <Routes>
                                    <Route path="*" element={<HomePage/>} />
                                    <Route path='/ContactUs' element={<ContactUsPage/>} />
                                    <Route path='/Faqs' element={<FaqsPage/>} />
                                    <Route path='/PrivacyCookieNotice' element={<PrivacyCookieNoticePage/>} />
                                    <Route path='/UseOfCookies' element={<UseOfCookiesPage/>} />
                                    <Route path='/PaymentProcess' element={<PrivateRoute><PaymentProcessPage/></PrivateRoute>} />
                                    <Route path='/CheckAvailability/:mhid/:mhname' element={<PrivateRoute><CheckAvailabilityPage/></PrivateRoute>} />
                                    <Route path='/Motorhome/:mhid/:mhname' element={<PrivateRoute><MotorhomePage/></PrivateRoute>} />
                                    <Route path='/BookingDetails/:bookingId/:mhname' element={<PrivateRoute><BookingDetailsPage/></PrivateRoute>} />
                                    <Route path='/BookingPayments/:bookingId/:mhname' element={<PrivateRoute><BookingPaymentsPage/></PrivateRoute>} />
                                    <Route path='/LicenceCheck/:bookingId' element={<PrivateRoute><LicenceCheckPage/></PrivateRoute>} />
                                    <Route path='/MyAccount/:tab' element={<PrivateRoute><MyAccountPage/></PrivateRoute>} />
                                </Routes>
                            </Layout>
                        </AppInsightsContext.Provider>
                    </ConfigContextProvider>
                </MsalProvider>
            </BrowserRouter>
        );
    }
    else {
        return <></>
    }
}

export default App;